const FooterDesign = () => {
  return (
    <div className="d-flex mt-4">
      <img
        className="footer-design-img"
        src="designs/sponsorDesign.svg"
        alt="footer-design"
      ></img>
    </div>
  );
};

export default FooterDesign;
